import { createContext, useContext, useState, createElement } from "react";
import { DICT } from "./content";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lb-lang") || "sv");
  const change = (l) => {
    localStorage.setItem("lb-lang", l);
    document.documentElement.lang = l;
    setLang(l);
  };
  return createElement(LangCtx.Provider, { value: { lang, setLang: change, t: DICT[lang] } }, children);
};

export const useLang = () => useContext(LangCtx);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
